<template>
  <BCard no-body>
    <BCardHeader class="pb-50">
      <h5> {{$t("Filters")}} </h5>
    </BCardHeader>
    <BCardBody>
      <BRow>
        <BCol cols="12" md="4" class="mb-md-0 mb-2" >
          <label>{{$t('Rol')}}</label>
          <vSelect v-model="roleFilter" label="name" :options="roles" class="w-100" :reduce="val => val.id" v-if="roles"  />
        </BCol>
        <BCol cols="12" md="4" class="mb-md-0 mb-2" >
          <label>{{$t('Status')}}</label>
          <vSelect v-model="statusFilter" :options="status" class="w-100" :reduce="val => val.value" v-if="status" />
        </BCol>
        <BCol cols="12" md="4" class="mb-md-0 mb-2" v-if="groups && groups.length>1" >
          <label>{{$t('Group')}}</label>
          <vSelect v-model="groupFilter" label="name" :options="groups" class="w-100" :reduce="val => val.id" v-if="groups" />
        </BCol>
      </BRow>
    </BCardBody>
  </BCard>
</template>

<script>
import { inject } from '@vue/composition-api';
import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, },
  setup(){
    const roleFilter = inject('roleFilter')
    const statusFilter = inject('statusFilter')
    const groupFilter = inject('groupFilter')
    const roles = inject('roles')
    const status = inject('status')
    const groups = inject('groups')

    return {
        roleFilter,
        statusFilter,
        groupFilter,
        roles,
        status,
        groups
    }
  }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
